<template>
    <div class="dialog">
        <el-card class="box-card" shadow="always" :body-style="{ padding: '0px' }">
            <div class="a">四川省安全生产培训教师证书信息</div>
            <div class="input">
                <div class="avater">
                    <img :src="'../../static/photo/' + this.$route.query.info[0].person.id_number + '.jpg'" border="1"></img>
                </div>
                <div v-for="cert in certs">
                    <el-row :gutter="8">
                        <el-col :span="24">
                            <el-tag
                                class="label"
                                type="danger">
                                {{cert.name}}
                            </el-tag>
                        </el-col>
                    </el-row>
                    <el-row :gutter="8">
                        <el-col :span="7">
                            <div>
                                <el-tag
                                    class="label"
                                    v-for="tag in cert.value"
                                    :key="tag.name"
                                    type="success">
                                    {{tag.name}}
                                </el-tag>
                            </div>
                        </el-col>
                        <el-col :span="17">
                            <div>
                              <el-tag
                                class="label"
                                v-for="tag in cert.value"
                                :key="tag.name">
                                {{tag.value}}
                              </el-tag>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-card>
    </div>
</template>
<script>
  import Vue from 'vue';
  var nzhcn = require("nzh/cn")
  export default {
    name: 'CertInfo',
    components: {
    },
    data() {
      return {
        tags: [
        ],
        certs: [
        ]
      };
    },
    mounted: function() {
      console.log(this.$route.query.info)
      for (let index in this.$route.query.info) {
        this.tags = [
          { name: '证号: ', value: this.$route.query.info[index].serial},
          { name: '姓名: ', value: this.$route.query.info[index].person.name},
          { name: '性别: ', value: this.$route.query.info[index].person.gender},
          { name: '身份证号: ', value: this.$route.query.info[index].person.id_number},
          { name: '初领日期: ', value: this.$route.query.info[index].first_init_time},
          { name: '有效期限: ', value: this.$route.query.info[index].init_time + ' 至 ' + this.$route.query.info[index].valid_time},
          // { name: '任教科目: ', value: this.$route.query.info[index].subject},
        ];
        if (this.$route.query.info[index].organization == 'NULL') {
          this.tags.push({ name: '工作单位: ', value: ''});
        } else {
          this.tags.push({ name: '工作单位: ', value: this.$route.query.info[index].organization});
        }
        if (this.$route.query.info[index].person.professional_title == '') {
          this.tags.push({ name: '职称: ', value: '无'});
        } else {
          this.tags.push({ name: '职称: ', value: this.$route.query.info[index].person.professional_title});
        }
        for (var i = 0; i < this.$route.query.info[index].training_record.length; i++) {
          if(i == 0) {
            // this.tags.push({ name: '第一次培训时间:', value: this.$route.query.info[index].training_record[i].training_time});
            this.tags.push({ name: '理论(初训成绩): ', value: this.$route.query.info[index].training_record[i].score_theory});
            this.tags.push({ name: '实操(初训成绩): ', value: this.$route.query.info[index].training_record[i].score_practice});
          };
          if(i == 1) {
            this.tags.push({ name: '第一次复训时间: ', value: this.$route.query.info[index].training_record[i].training_time});
            this.tags.push({ name: '理论(初次复训): ', value: this.$route.query.info[index].training_record[i].score_theory});
            this.tags.push({ name: '实操(初次复训): ', value: this.$route.query.info[index].training_record[i].score_practice});
          };
          if(i == 2) {
            this.tags.push({ name: '第二次复训时间: ', value: this.$route.query.info[index].training_record[i].training_time});
            this.tags.push({ name: '理论(二次复训): ', value: this.$route.query.info[index].training_record[i].score_theory});
            this.tags.push({ name: '实操(二次复训): ', value: this.$route.query.info[index].training_record[i].score_practice});
          };
        };
        this.certs.push({name: '证书' + nzhcn.encodeS((Number(index) + 1)), value: this.tags});
      };
    },
    methods: {

    }
  }
</script>
<style scoped>
  html,
  body {
    margin: 0;
    padding: 0;
    position: relative;
  }

  .dialog {
    width: 100%;
    height: 100%;
    text-align: center;
  }

  .a {
    height: 53px;
    width: 100%;
    line-height: 52px;
    font-size: 22px;
    font-weight: bold;
    color: #fff;
    background-color: #5BB64D;
    text-align: center;
    display: block;
    text-decoration: none;
  }

  .box-card {
    width: 600px;
    margin:0 auto;
    margin-top: 150px;
    text-align: center;
    border-radius: 5px;
  }

  .label {
    text-decoration: none;
    font-size: 16px;
    font-weight: bold;
    width: 100%;
    margin-top: 10px;
    border-radius: 5px;
  }

  .button:hover {
    color: #fff;
    background-color: #1C3717;
    text-decoration: none;
  }

  h1 {
    text-align: center;
  }

  img {
    width: 96px;
    border: 1;
    object-fit: fill;
    border-radius: 5px;
    border-color: rgba(103,194,58,.2);
  }

  .input {
    padding: 30px;
    text-align: center;
  }

  .avater {
    padding: 15px;
    text-align: center;
    overflow: hidden;
  }

  .item {
    margin-tip: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CertInfo.vue